export default __webpack_public_path__ + "static/media/snackFasting.a7071305.svg";